/* @sravni/react-header version 0.2.43 */
import { __assign, __spreadArray, __read } from 'tslib';
import React__default from 'react';
import { observe } from 'react-intersection-observer';
import { isNumber } from '@sravni/react-utils';

var useMenuIntersectionObservers = function (props) {
    var menu = props.menu, optionsOutput = props.options, promoLinksCallback = props.promoLinksCallback, topMenuLinksCallback = props.topMenuLinksCallback;
    var options = React__default.useMemo(function () { return (__assign({ threshold: 1 }, optionsOutput)); }, [optionsOutput]);
    var checkPromoLink = function (item) {
        if (!item.href)
            return false;
        return item.href.indexOf('promo=1') > -1;
    };
    var getMenuLinks = function (menu, depth) {
        isNumber(depth) ? depth++ : (depth = 1);
        return menu.reduce(function (acc, menuItem) {
            var deepLinks = menuItem.children && menuItem.children.length > 0 ? getMenuLinks(menuItem.children, depth) : [];
            var topLevelLinks = depth === 1 ? [menuItem] : [];
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(acc)), __read(topLevelLinks)), __read((checkPromoLink(menuItem) ? [menuItem] : []))), __read((deepLinks.length > 0 ? deepLinks : [])));
        }, []);
    };
    var menuLinks = React__default.useMemo(function () { return getMenuLinks(menu); }, [menu]);
    var refs = React__default.useMemo(function () {
        return menuLinks.reduce(function (acc, link) {
            var _a;
            var ref = React__default.createRef();
            return __assign(__assign({}, acc), (_a = {}, _a["" + link.text + link.href] = ref, _a));
        }, {});
    }, [menuLinks]);
    React__default.useEffect(function () {
        var destroys = [];
        Object.values(refs).forEach(function (ref) {
            if (!ref.current)
                return;
            var isTopMenuRef = ref.current.nodeName === 'DIV';
            var callback = isTopMenuRef ? topMenuLinksCallback : promoLinksCallback;
            var destroy = observe(ref.current, callback, options, true);
            destroys.push(destroy);
        });
        return function () {
            destroys.forEach(function (destroy) { return destroy(); });
        };
    }, [promoLinksCallback]);
    return {
        refs: refs
    };
};

export { useMenuIntersectionObservers };
//# sourceMappingURL=useMenuIntersectionObservers.js.map
